import React from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui';
import { getEntities } from 'dash-front/selectors';

const Fact = ({ fact: { message }, id, onClick }) => {
    return message ? <MenuItem onTouchTap={() => onClick(message)}>{message}</MenuItem> : null;
};

const FactEnhanced = connect((state, { id }) => {
    return { fact: getEntities(state).facts[id] };
})(Fact);

export const FactList = ({ facts, onClick }) => {
    return (
        <div>
            {facts.map((id, index) => (
                <div key={id}>
                    <FactEnhanced id={id} onClick={onClick} />
                </div>
            ))}
        </div>
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/PostFacts.js
 **/